import React, { useEffect, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthenticationService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { FloatingPanelService } from '../../services/floating-panel-service.js';
import { FloatingPanel } from '../floating-panel/floating-panel.js';
/*
  This component does not behave like a common React component would be expected to behave, firstly, it does not
  properly render anything using React's own render method, instead, it will open the floating panel directly in
  the document body when any call is made to the FloatingPanelService to open a new floating panel.

  The component is also responsible for the removal of these divs from the document body, as it will not pass through
  the React component life cycle.
*/
function FloatingPanelManager() {
    const panels = useRef(new Map());
    const closeAllPanels = () => {
        for (const [id] of panels.current) {
            closePanel(id);
        }
    };
    const closePanel = (id) => {
        const panel = panels.current.get(id);
        if (!panel) {
            return;
        }
        const { container, root } = panel;
        root.unmount();
        container.remove();
        panels.current.delete(id);
    };
    const createPanel = (props) => {
        return (React.createElement(FloatingPanel, { ...props }));
    };
    const onCreatePanel = (id, panel) => {
        if (panels.current.has(id)) {
            throw Error(`[Floating Panel Manager]: Floating Panel with id '${id}' already exists.`);
        }
        const container = document.createElement('div');
        container.style.height = '100%';
        container.style.pointerEvents = 'none';
        container.style.position = 'absolute';
        container.style.width = '100%';
        document.body.append(container);
        const panelElement = createPanel(panel);
        const root = createRoot(container);
        panels.current.set(id, { container, panel, root });
        root.render(panelElement);
    };
    useEffect(() => {
        const listeners = [
            AuthenticationService.listenLogout(() => closeAllPanels()),
            FloatingPanelService.addCloseListener(closePanel),
            FloatingPanelService.addOpenListener(onCreatePanel),
        ];
        return () => {
            listeners.forEach(callback => callback());
        };
    }, []);
    return null;
}
export { FloatingPanelManager, };
//# sourceMappingURL=floating-panel-manager.js.map